var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.83013,
    cy: 10.83,
    rx: 9.83013,
    ry: 9.83,
    fill: "#40B449"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72893 14.9258C10.5504 14.9237 11.0838 13.7368 11.4171 13.1655C13.2687 9.98861 15.2192 5.63534 17.8601 2.72824C18.1891 2.36564 19.2084 1.75218 18.7031 1.16823C18.3181 0.788768 17.9396 1.13028 17.6429 1.41699C15.3289 3.66214 13.3053 7.42935 11.8063 10.2247C11.1827 11.3863 10.6343 12.8641 9.68807 13.8148C9.21281 13.3511 8.77195 11.03 7.44508 9.02941C7.17626 8.62255 6.44939 7.47573 5.8752 7.9353C5.37412 8.40541 6.35046 9.29925 6.62143 9.72509C8.09238 12.0229 8.26443 14.93 9.72678 14.9258H9.72893Z",
    fill: "white",
    stroke: "white"
  })));
};
export default SvgCheckbox;